export const inputCls =
  "focus-brand w-full rounded-xl border border-line bg-white px-3.5 py-2.5 text-sm text-ink placeholder:text-muted2 outline-none transition-colors";

export const Panel = ({ children, className = "", ...rest }) => (
  <div className={`card-soft p-5 ${className}`} {...rest}>
    {children}
  </div>
);

export const TEMP_STYLES = {
  hot: "bg-red-50 text-red-600 ring-red-100",
  warm: "bg-mint text-brandDark ring-emerald-100",
  cold: "bg-sky-50 text-sky-600 ring-sky-100",
};

export const TempBadge = ({ temp }) => (
  <span
    className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ring-1 ${
      TEMP_STYLES[temp] || TEMP_STYLES.warm
    }`}
  >
    {temp}
  </span>
);

export const money = (n) =>
  n == null
    ? "—"
    : n >= 10000000
    ? `₹${(n / 10000000).toFixed(2)} Cr`
    : `₹${Math.round(n / 100000)} L`;

export const when = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const ago = (iso) => {
  if (!iso) return "—";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};
